import { 
    CAM_VIEW_CHANGED,
    SET_SINGLE_VIEW,
    SET_CAM_BROWSER_CAM,
    SET_CAM_GROUP_SINGLE,
    SET_CAM_GROUP_QUAD
  } from './types';
  
export const camViewChange = camset => {
    return {
      type: CAM_VIEW_CHANGED,
      payload: camset
    };
  };

  export const setSingleView = (cam) => {
    return {
      type: SET_SINGLE_VIEW,
      payload: cam
    };
  }

  export const setCameraBrowserCam = cam => {
    return {
      type: SET_CAM_BROWSER_CAM,
      payload: cam
    };
  }

  // used for DVRS with more than 16 cameras
  export const setCamGroupSingle = type => {
    return {
      type: SET_CAM_GROUP_SINGLE,
      payload: type
    };
  }

  // used for DVRS with more than 32 cameras
  export const setCamGroupQuad = type => {
    return {
      type: SET_CAM_GROUP_QUAD,
      payload: type
    };
  }
